import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this._rafId = requestAnimationFrame(() => this.resize())
  }

  disconnect() {
    if (this._rafId) cancelAnimationFrame(this._rafId)
  }

  resize() {
    this.element.style.maxHeight = ""

    const scrollableAncestor = this.#findOverflowingAncestor()
    if (!scrollableAncestor) return

    const overflow = scrollableAncestor.scrollHeight - scrollableAncestor.clientHeight
    if (overflow > 0) {
      const currentHeight = this.element.getBoundingClientRect().height
      this.element.style.maxHeight = `${Math.max(currentHeight - overflow, 200)}px`
    }
  }

  #findOverflowingAncestor() {
    let node = this.element.parentElement
    while (node) {
      const style = getComputedStyle(node)
      const overflowY = style.overflowY
      if ((overflowY === "auto" || overflowY === "scroll") && node.scrollHeight > node.clientHeight) {
        return node
      }
      node = node.parentElement
    }
    return null
  }
}
